import { useState } from 'react';

import { Button } from '@mui/material';

import { ConfirmModal } from 'components/modal';
import { useMutateReverter } from 'pages/financeiro/reembolso/manutencao-reembolso/hooks';

export function ManutencaoReembolsoReverterButton({ idApuracao, idStatusApuracao }: { idApuracao: number; idStatusApuracao: number }) {
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const { handleReverter, isLoading } = useMutateReverter();
    const isFinalizadoSucesso = idStatusApuracao === 4;
    const isFinalizadoFalha = idStatusApuracao === 5;

    return (
        <>
            <ConfirmModal
                open={openConfirmModal}
                setOpen={setOpenConfirmModal}
                text="Tem certeza que deseja reverter o reembolso selecionado?"
                confirm={() => handleReverter(idApuracao)}
            />

            <Button
                variant="contained"
                size="small"
                loading={isLoading}
                disabled={!isFinalizadoSucesso && !isFinalizadoFalha}
                sx={{ px: 1, py: 0 }}
                onClick={() => setOpenConfirmModal(true)}
            >
                Reverter
            </Button>
        </>
    );
}
